/* src/app/features/contratacao/operacao/amortizacao/amortizacao-detalhe/amortizacao-detalhe.component.css */
.linha-titulo-fluxo-amort-antecipada {
  margin-top: 10px;
}
/*# sourceMappingURL=amortizacao-detalhe.component.css.map */
